export const getCityFullName = (city, lang) => {
    //area - alan
    //district - region

    let cityFullName = city.city
    if (city.district) {
        cityFullName += `, ${city.district} ${lang === "tr" ? "region" : "район"}`
    }
    if (city.area) {
        cityFullName += `, ${city.area} ${lang === "tr" ? "alan" : "обл."}`
    }
    return cityFullName
}